import React from 'react';
import { useLocation } from 'react-router-dom';

import DefaultLayout from '../../_layouts/default';

import List from './List';
import New from './New';

const Sponsorships: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <DefaultLayout>
      {pathname === '/items/sponsorships' ? <List /> : <New />}
    </DefaultLayout>
  );
};

export default Sponsorships;
